import AddressProofError from './AddressProof/AddressProofError';
class AddressProofFileExtensionIsInvalid extends AddressProofError {
    constructor(options) {
        super('Address proof file extension is invalid', options);
    }
}
export default AddressProofFileExtensionIsInvalid;
